import { WarehouseLocationGroupCreatePage } from '@/features/warehouse-location-group/pages/WarehouseLocationGroupCreatePage';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/warehouse-location-group/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["warehouse_location_group.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: WarehouseLocationGroupCreatePage,
})
